export enum GroupByKey {
  StackSlug = "stackSlug",
  WorkerPoolSlug = "workerPoolSlug",
  Public = "public",
  RunState = "runState",
  RunType = "runType",
}
